import React from 'react';
import Card from 'components/cards/Card01';
import AnalyticsSerive from 'api/services/AnalyticsService';
import LayoutWrapper from 'components/LayoutWrapper';
import { useTranslation } from 'react-i18next';
import { getI18nValue } from 'utils/Utils';
import { useAxios } from 'hooks/useAxios';
import { HiUsers } from 'react-icons/hi';
import PropTypes from 'prop-types';

function UniqueUsersCard({ dateRanges, channel, language }) {
    const { t } = useTranslation();
    const [data, error, loading] = useAxios(
        AnalyticsSerive.getUniqueUsers(dateRanges, channel, language)
    );

    return (
        <LayoutWrapper error={error} loading={loading} variant="cards" isEmpty={!loading && !data} className="h-full">
            {!!data && (
                <Card
                    title={t(getI18nValue('analytics.kpi.unique_users', 'title'))}
                    description={t(getI18nValue('analytics.kpi.unique_users', 'description'))}
                    value={data.unique_users}
                    icon={<HiUsers />}
                />
            )}
        </LayoutWrapper>
    );
}

UniqueUsersCard.propTypes = {
  dateRanges: PropTypes.object.isRequired,
  channel: PropTypes.string,
  language: PropTypes.string,
};

export default UniqueUsersCard;
